(function () {
  'use strict';

  var PUB_PREFIX = '/uploads/public/';
  var THUMB_STEP = 50;
  var THUMB_MIN = 100;
  var THUMB_MAX = 3000;
  var SIZE_THRESHOLD = 2; // sub-pixel rounding tolerance

  function thumbnailUrl(src, width) {
    var idx = src.indexOf(PUB_PREFIX);
    if (idx === -1) return null;
    if (width < THUMB_MIN) return null;
    var fname = src.substring(idx + PUB_PREFIX.length);
    if (/\.gif$/i.test(fname)) return null;
    var qw = Math.ceil(width / THUMB_STEP) * THUMB_STEP;
    if (qw > THUMB_MAX) qw = THUMB_MAX;
    return '/uploads/thumbnails/' + qw + '/public/' + fname;
  }

  function fitsInView(fullW, fullH, img) {
    return fullW <= img.clientWidth + SIZE_THRESHOLD &&
           fullH <= img.clientHeight + SIZE_THRESHOLD;
  }

  function disableLightbox(link, img) {
    link.removeAttribute('data-lightbox');
    link.removeAttribute('href');
    link.style.cursor = 'default';
    var icon = link.querySelector('.magnifying-glass-icon');
    if (icon) icon.remove();
    img.style.cursor = 'default';
  }

  function checkOnLoad(img, callback) {
    function run() {
      if (img.clientWidth > 0) {
        callback();
      } else {
        requestAnimationFrame(callback);
      }
    }
    if (img.complete && img.naturalWidth > 0) {
      run();
    } else {
      img.addEventListener('load', run, { once: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // --- Prose content images ---
    var containers = document.querySelectorAll('.prose-content');
    containers.forEach(function (container, idx) {
      var groupName = 'content-' + idx;
      var imgs = container.querySelectorAll('img');
      imgs.forEach(function (img) {
        if (img.closest('a')) return;

        var originalSrc = img.getAttribute('src') || img.src;
        var displaySrc = originalSrc;
        var usedThumbnail = false;

        var widthAttr = img.getAttribute('width');
        if (widthAttr) {
          var w = parseInt(widthAttr, 10);
          var thumb = thumbnailUrl(originalSrc, w);
          if (thumb) {
            displaySrc = thumb;
            usedThumbnail = true;
          }
        }

        var link = document.createElement('a');
        link.href = originalSrc;
        link.setAttribute('data-lightbox', groupName);
        link.setAttribute('data-caption', img.getAttribute('title') || img.alt || '');
        link.className = 'prose-content-lightbox';

        var align = img.getAttribute('data-align');
        if (align) {
          link.setAttribute('data-align', align);
          img.removeAttribute('data-align');
        }

        img.parentNode.insertBefore(link, img);
        link.appendChild(img);

        if (displaySrc !== originalSrc) {
          img.src = displaySrc;
        }

        var icon = document.createElement('span');
        icon.className = 'magnifying-glass-icon';
        var i = document.createElement('i');
        i.className = 'icon-maximize-2';
        icon.appendChild(i);
        link.appendChild(icon);

        if (!usedThumbnail) {
          checkOnLoad(img, function () {
            if (fitsInView(img.naturalWidth, img.naturalHeight, img)) {
              disableLightbox(link, img);
            }
          });
        }
      });
    });

    // --- Template-based lightbox links with data-width/data-height ---
    var templateLinks = document.querySelectorAll('a[data-lightbox][data-width][data-height]');
    templateLinks.forEach(function (link) {
      var img = link.querySelector('img');
      if (!img) return;

      var origWidth = parseInt(link.getAttribute('data-width'), 10);
      var origHeight = parseInt(link.getAttribute('data-height'), 10);
      if (isNaN(origWidth) || isNaN(origHeight)) return;

      checkOnLoad(img, function () {
        if (fitsInView(origWidth, origHeight, img)) {
          disableLightbox(link, img);
        }
      });
    });
  });
})();
